import { brandApi } from '@/api/account-management/brandApi';
import { type Brand } from '@/models/account-management/Brand';
import { useQuery } from '@tanstack/react-query';
import { useAppContext } from '../AppContext';

// The brand currently selected in the global top-bar scope (with its config flags, e.g. touchTabFeedbackEnabled).
export const useCurrentBrand = () => {
    const app = useAppContext();
    return useQuery<Brand>({
        queryKey: ['brand', app.brandId],
        enabled: !!app.brandId,
        queryFn: () => brandApi.get(app.brandId!),
        staleTime: Infinity,
    });
};
